module.exports = __webpack_public_path__ + "static/media/morvan.7ecacd0c.jpg";